import React, { useState } from "react";
import {
  eventShareText,
  facebookShareUrl,
  whatsappShareUrl,
} from "../eventSharing";
import { eventCanonicalUrl } from "../eventRoutes";

async function copyText(value) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }

  const textarea = document.createElement("textarea");
  textarea.value = value;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  textarea.remove();
}

export default function EventShareActions({ event }) {
  const [message, setMessage] = useState("");
  const url = eventCanonicalUrl(event);
  const shareText = eventShareText(event);
  const canUseNativeShare =
    typeof navigator !== "undefined" && typeof navigator.share === "function";

  const handleNativeShare = async () => {
    try {
      await navigator.share({ title: event.title, text: shareText, url });
      setMessage("Shared");
    } catch (error) {
      if (error?.name !== "AbortError") setMessage("Sharing was not available.");
    }
  };

  const handleCopy = async () => {
    try {
      await copyText(url);
      setMessage("Link copied");
    } catch {
      setMessage("Could not copy the link. Please copy it from the address bar.");
    }
  };

  if (!url) return null;

  const actionClass =
    "inline-flex min-h-11 items-center justify-center rounded-xl border border-white/15 bg-white/10 px-4 py-2 text-sm font-semibold text-white hover:bg-white/15";

  return (
    <section className="mt-8 border-t border-white/10 pt-6" aria-labelledby="share-event-title">
      <h2 id="share-event-title" className="text-lg font-semibold">Share this event</h2>
      <div className="mt-3 flex flex-wrap gap-2">
        {canUseNativeShare ? (
          <button type="button" onClick={handleNativeShare} className={actionClass}>
            Share
          </button>
        ) : null}
        <a
          href={whatsappShareUrl(event, url)}
          target="_blank"
          rel="noopener noreferrer"
          className={actionClass}
        >
          WhatsApp
        </a>
        <a
          href={facebookShareUrl(event, url)}
          target="_blank"
          rel="noopener noreferrer"
          className={actionClass}
        >
          Facebook
        </a>
        <button type="button" onClick={handleCopy} className={actionClass}>
          Copy link
        </button>
      </div>
      <p className="mt-2 min-h-5 text-sm text-white/65" aria-live="polite">{message}</p>
    </section>
  );
}
